import {SortSchema} from '@cypro/ui/schemas'
import * as z from 'zod'

export const WardFormSchema = z.object({
  name: z.string().trim().nonempty(),
  code: z.string().trim().nonempty(),
  sectionId: z.array(z.string()).nonempty(),
  costCenterNumber: z.string().trim().nonempty(),
  orderNumber: z.string(),
  movementType: z.string(),
})

export const WardsFiltersSchema = z.object({
  search: z.string().optional(),
  sections: z.array(z.uuidv7()).optional(),
})

export const WardsSearchSchema = z.object({
  filters: WardsFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})
